/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UsageConfigSpec } from './usageConfigSpec';


export interface UsageConfigListSpec { 
    /**
     * List of usage configs
     */
    usage_configs: Array<UsageConfigSpec>;
}

